import React from "react";
import { Badge } from "react-bootstrap";

export const COLUMNS = [
  {
    Header: "District Name",
    accessor: "DistrictName",
    className: " ",
  },
  {
    Header: "No of Institutes",
    accessor: "CollegeCount",
    className: " ",
  },
  {
    Header: "Enrolled Student",
    accessor: "TotalStaff",
    className: " ",
  },
  {
    Header: "Present Student",
    accessor: "EnrolledStaff",
    className: " ",
  },
  {
    Header: "Absent Student",
    accessor: "NotEnrolledStaff",
    className: " ",
  },
  {
    Header: "Action",
    accessor: "Status",
    className: " ",
  },
  {
    Header: "Staff ID",
    accessor: "StaffID",
    className: " ",
  },
];



export const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <>
      <span className="d-flex"
        style={{ minWidth: "100px" }}
      >
        <input
          value={filter || ""}
          onChange={(e) => setFilter(e.target.value)}
          className="form-control mb-4"
          placeholder="Search..."
        />
      </span>
    </>
  );
};


export const Badges = (props) => {
  return (<div

    className="d-flex ms-auto align-items-center justify-content-center mb-4 me-1 flex-wrap"
  >
    <div className="m-2">
      <Badge bg="" className=" bg-success ">
        {" "}
        P
      </Badge>{" "}
      Present
    </div>
    <div className="m-2">
      <Badge bg="" className=" bg-danger ">
        {" "}
        A
      </Badge>{" "}
      Absent
    </div>
    <div className="m-2">
      <Badge bg="" className="bg-info">
        {" "}
        NE
      </Badge>{" "}
      Not Enrolled
    </div>
    <div className="m-2">
      <Badge bg="" className=" holiday ">
        {" "}
        H
      </Badge>{" "}
      Holiday
    </div>
    <div className="m-2">
      <Badge bg="" className=" sunday ">
        {" "}
        SU
      </Badge>{" "}
      Sunday
    </div>

    <div className="m-2">
      <Badge bg="" className=" sunday ">
        {" "}
        SS
      </Badge>{" "}
      Second Saturday
    </div>
    {props.type === "staff" &&
      <div className="m-2">
        <Badge bg="" className=" bg-warning ">
          {" "}
          OD
        </Badge>{" "}
        ON Duty
      </div>
    }
        {props.type === "student" &&
      <div className="m-2">
        <Badge bg="" className=" bg-warning ">
          {" "}
          AA
        </Badge>{" "}
        Authorised Absent
      </div>
    }
  </div>)
}

export const badgecolors = (type) => {
  switch (type) {
    case "P":
      return "bg-success";
    case "A":
      return "bg-danger";
    case "NE":
      return "bg-info";
    case "H":
      return "holiday";
    case "OD":
      return "bg-warning";
    case "AA":
      return "bg-warning";
    default:
      return "sunday";
  }
}

export const badgevalue = (type) => {
  switch (type) {
    case "P":
      return "Present";
    case "A":
      return "Absent";
    case "NE":
      return "Not Enrolled";
    case "H":
      return "Holiday";
    case "OD":
      return "On Duty";
    case "AA":
      return "Authorised Absent";
    case "SS":
      return "Second Saturday";
      case "SU":
        return "Sunday";  
    default:
      return " ";
  }
}